import {AziendaEditorProps} from "../Azienda.generalita.page";
import InputEx from "../../../components/wrapperComponents/InputEx";
import React, {useEffect, useMemo, useState} from "react";
import {useForm} from "react-hook-form";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {useGetCCNLQuery, useGetEnteAssicurativoQuery, useGetEntePrevidenzialeQuery, useGetSedeInailQuery} from "@commons/features/sistema/tabelleDiSistema.api";
import FormButtons from "../../../components/FormButtons";
import {MONTHS} from "@utilities/constAppUtils";
import {ComboBoxCCNL, ComboBoxEnteAss, ComboBoxEntePrev, ComboBoxInail, ComboBoxSettoreCCNL} from "../../../components/comboBox/ComboBoxInquadramento";
import {CCNLRecord} from "@commons/mapping/SettoriCCNL";
import Input from "../../../components/wrapperComponents/Input";
import Select from "../../../components/wrapperComponents/Select";

const InquadramentoAziendaEditor: React.FC<AziendaEditorProps> = ({defaultValues, resource, onSubmit, onCancel}) => {
    const {handleSubmit, watch, register, getValues, setValue, reset, control, formState: {errors}} = useForm<AziendaRecord>();

    const currentValues: AziendaRecord = useMemo(() => {
        return {
            ...defaultValues, ...resource,
        };
    }, [resource, defaultValues]);

    useEffect(() => {
        reset(currentValues);
    }, [reset, currentValues]);

    const {data: dataCCNL, isLoading: isLoadingCCNL} = useGetCCNLQuery();
    const {data: dataEntePrev, isLoading: isLoadingEnte} = useGetEntePrevidenzialeQuery();
    const {data: dataEnteAss, isLoading: isLoadingEnteAss} = useGetEnteAssicurativoQuery();
    const {data: dataSedeInail, isLoading: isLoadingSedeInail} = useGetSedeInailQuery();

    function onHandleSubmit(newValues: AziendaRecord) {
        onSubmit({
            ...newValues,
            codContrattoUNILAV: newValues.CCNL!.codContrattoUNILAV ? newValues.CCNL!.codContrattoUNILAV : '',
            codContrattoCCNL: newValues.CCNL!.codContratto ? newValues.CCNL!.codContratto : '',
            CCNL: undefined,
            codContrattoUNILAVDirigenti: newValues.CCNLDirigenti!.codContrattoUNILAV ? newValues.CCNLDirigenti!.codContrattoUNILAV : '',
            codContrattoCCNLDirigenti: newValues.CCNLDirigenti!.codContratto ? newValues.CCNLDirigenti!.codContratto : '',
            CCNLDirigenti: undefined,
        })
    }

    const [enteCassa, setEnteCassa] = useState<string | undefined>(undefined);
    const [inizioFY, setInizioFY] = useState<number | undefined>(undefined);
    const [gesitioneInail, setGesitioneInail] = useState<any>(resource.idGestioneInail);

    const selOptMonths = (
        MONTHS.map((item, index) => (
            <option key={index} value={item.id} className="text-gray-900 relative cursor-default select-none py-2 pl-3 pr-9">
                {item.name}
            </option>))
    );

    const settoreCorrente = watch('settoreCCNL');
    const resetSettore = () => {

        setValue('codContrattoUNILAV', null);
    }

    let contratti;
    const getCCNLSpecifiche = (settore: string) => {
        if (dataCCNL) {
            const res = dataCCNL.find(el => el.settore === settore);
            contratti = res ? res.contratti : undefined;
            return contratti;
        } else return undefined;
    }

    const findContrattoSelected = (contratti: CCNLRecord[] | undefined, codContrattoUNILAV: string | null, codContratto: string | null) => {
        if (contratti !== undefined && codContrattoUNILAV !== null && codContrattoUNILAV !== undefined) {
            if (codContrattoUNILAV !== '*')
                return contratti.find(el => el.codContrattoUNILAV === codContrattoUNILAV);
            else return contratti.find(el => el.codContratto === codContratto);
        } else return undefined;
    }

    return <>
        <form className="p-1" onSubmit={handleSubmit(onHandleSubmit)}>

            <div className="flexRowWrapFull">
                <div className="sm1-2P">
                    <ComboBoxSettoreCCNL<AziendaRecord> control={control} name="settoreCCNL" defaultValue={defaultValues.settoreCCNL} onChange={resetSettore}
                                                        label="CCNL settore" data={dataCCNL} isLoading={isLoadingCCNL}/>
                </div>
                <div className="sm1-2P">
                    <ComboBoxCCNL control={control} name="codContrattoUNILAV" defaultValue={defaultValues.codContrattoCCNL}
                                  label={`CCNL specifica ${settoreCorrente}`} data={settoreCorrente ? getCCNLSpecifiche(settoreCorrente) : undefined}
                                  isLoading={isLoadingCCNL} valueSelected={findContrattoSelected(contratti, resource.codContrattoUNILAV, resource.codContrattoCCNL)}/>
                </div>
            </div>
            <div className="flexRowWrapFull">
                <div className="sm1-2P">
                    <label className="block text-sm font-semibold mb-1">CCNL settore Dirigenti</label>
                    <Input register={register} disabled={true} value="Dirigenti" name="CCNLDirigenti"/>
                </div>
                <div className="sm1-2P">
                    <ComboBoxCCNL control={control} name="codContrattoCCNLDirigenti" defaultValue={defaultValues.codContrattoCCNLDirigenti}
                                  label="CCNL specifica Dirigenti" data={getCCNLSpecifiche('Dirigenti')}
                                  isLoading={isLoadingCCNL}
                                  valueSelected={findContrattoSelected(contratti, resource.codContrattoUNILAVDirigenti, resource.codContrattoCCNLDirigenti)}/>
                </div>
            </div>
            <div className="flexRowWrapFull">
                <Select label="Inizio anno fiscale" id="selMeseConvenzione" name="inizioFY"
                        divClass="sm1-2P"
                        register={register}>
                    {selOptMonths}
                </Select>
                <div className="sm1-2P">
                    <InputEx
                        label="Classificazione delle attività economiche (Ateco 2007)"
                        name="codAteco"
                        register={register}
                    />
                </div>
            </div>

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Ente previdenziale</legend>
                <div className="flexRowWrapFull">
                    <div className="sm1-3P !pr-2">
                        <ComboBoxEntePrev control={control} name="codEntePrevidenziale" defaultValue={defaultValues.codEntePrevidenziale}
                                          data={dataEntePrev} isLoading={isLoadingEnte}/>
                    </div>
                </div>
            </fieldset>

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Ente assicurativo</legend>

                <div className="flexRowWrapFull">
                    <div className="sm1-3P !pr-2">
                        <ComboBoxEnteAss<AziendaRecord> label="Gestione" name="idGestioneInail" control={control} defaultValue={defaultValues.idGestioneInail}
                                                        data={dataEnteAss} isLoading={isLoadingEnteAss}/>
                    </div>
                    <div className="sm1-3P">
                        <ComboBoxInail<AziendaRecord> label="Sede" control={control} name="idSedeInail" defaultValue={defaultValues.idSedeInail}
                                                      data={dataSedeInail} isLoading={isLoadingSedeInail}
                        />
                    </div>
                    <div className="sm1-3P">
                        <InputEx
                            label="Codice &quot;ditta&quot;"
                            name="codDittaInail"
                            register={register}
                        />
                    </div>
                </div>
            </fieldset>

            <FormButtons onCancel={onCancel} resource={resource}/>

        </form>
    </>
}

export default InquadramentoAziendaEditor;